import { UserGraphicsQualityPreset, UserGraphicsQualityPresetTypes } from '@wg/web2clientapi/browser/getUserGraphicsQualityPreset';
import equal from 'fast-deep-equal/react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import VideoBackground from '~/components/VideoBackground/VideoBackground';
import { SANTA_CONFIRM_PURCHASE_VIDEO } from '~/Layouts/Themes/SantaPage/settings';
import { State } from '~/Reducers';
import { getStaticUrl } from '~/utils/utils';
import styles from './SantaCustomization.scss';

interface ISantaCustomization {
    children: React.ReactChild | React.ReactChild[];
}

interface IStateSelector {
    userGraphics: UserGraphicsQualityPreset;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        userGraphics: state.ReducerAccount.userGraphics,
    };
};

const SantaCustomization = ({ children }: ISantaCustomization) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const poster = getStaticUrl(require('./images/new_year_confirm_purchase_background.jpg'));
    const isLowGraphics = state.userGraphics?.preset === UserGraphicsQualityPresetTypes.LOW;

    return (
        <React.Fragment>
            <div className={styles.wrapper}>
                <VideoBackground
                    poster={poster}
                    video={isLowGraphics ? null : SANTA_CONFIRM_PURCHASE_VIDEO}
                    className={styles.background}
                    posterClassName={styles.poster}
                    videoClassName={styles.videoBackground}
                    withMask={true}
                    maskClassName={styles.mask}
                />
            </div>
            <>{children}</>
        </React.Fragment>
    );
};

export default SantaCustomization;
